import React, { useContext, useState, useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';
import { ValidationModeContext } from '../../../contexts/VendorPaymentValidationModeContext';
import ValidationModeEnum from './ValidationMode.enum';

const ExpenseInvoiceNumber = (props) => {
    const { index, expense, mode } = props;
    const { control, errors } = useFormContext();
    const [required, setRequired] = useState({ required: false });
    const validationMode = useContext(ValidationModeContext);

    useEffect(() => {
        setRequired({ required: expense?.status === ExpenseStatusValuesEnum.Approved });
    }, [expense?.status]);

    return (
        <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].invoiceNumber`}
                defaultValue={expense.invoice !== null ? expense.invoice : ''}
                rules={{
                    validate: (value) => {
                        if (
                            required.required &&
                            validationMode !== ValidationModeEnum.Save &&
                            !value
                        ) {
                            return 'Invoice Number is required.';
                        }
                        return true; // Passes in save mode
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        placeholder=""
                        id={`expense-invoice-number${index}`}
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        required={required}
                        label="Invoice Number"
                        error={Boolean(errors.expenseEntries?.[index]?.invoiceNumber)}
                        disabled={mode === 'vault'}
                        helperText={errors.expenseEntries?.[index]?.invoiceNumber?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseInvoiceNumber;
